import { isEmpty, pullAll, map, filter, isEqual } from "lodash";
import { useEffect, useRef } from "react";

import {
  findTreeNodes,
  insertChildrenNodes,
  reopenTreeToGroupNode,
} from "src/shared/TreeView/TreeView.util";
import rethrowUnlessAbort from "src/util/rethrowUnlessAbort";
import { filterOutNonVisibleGroups } from "./index.util";

const useAutoExpandTree = ({
  root,
  hierarchyIds,
  groupTypes,
  loadChildTeams,
  refreshTree,
  sortOption,
  createTreeNodeImpl,
  convertChildrenToArrayImpl,
}) => {
  const prevHierarchyIdsRef = useRef(null);

  useEffect(() => {
    if (isEmpty(hierarchyIds) || isEmpty(root)) {
      return;
    }

    const hierarchyChanged = !isEqual(
      hierarchyIds,
      prevHierarchyIdsRef.current
    );
    prevHierarchyIdsRef.current = hierarchyIds;

    const treeNodes = findTreeNodes(root, hierarchyIds);
    const loadedGroupIds = map(
      filter(treeNodes, (n) => !n.loading),
      "id"
    );

    const groupIds = pullAll([...hierarchyIds], loadedGroupIds);

    if (isEmpty(groupIds)) {
      // Only reopen when hierarchyIds changed — not on manual collapse for same team.
      if (hierarchyChanged) {
        reopenTreeToGroupNode(root, hierarchyIds);
        refreshTree();
      }
      return;
    }

    loadChildTeams({
      groupIds,
    })
      .then(({ groups }) => {
        const filteredGroups = filterOutNonVisibleGroups(groups);
        insertChildrenNodes(
          root,
          hierarchyIds,
          filteredGroups,
          groupTypes,
          sortOption,
          createTreeNodeImpl,
          convertChildrenToArrayImpl
        );
        reopenTreeToGroupNode(root, hierarchyIds);
        refreshTree();
      })
      .catch(rethrowUnlessAbort);
  }, [
    root,
    hierarchyIds,
    groupTypes,
    loadChildTeams,
    refreshTree,
    sortOption,
    createTreeNodeImpl,
    convertChildrenToArrayImpl,
  ]);
};

export default useAutoExpandTree;
